import axios from 'axios'

export default axios.create({
    baseURL: 'https://lpp-backend.lpn.co.th/api/parcel'
    // baseURL: 'http://127.0.0.1:8000/api/parcel'
})
